<template>
  <div class="home">
    <MenuBar />
    <div class="home-content">
      <div class="header">
        <h1>PDF Uploader</h1>
      </div>
    <div
      class="drop-area"
      @dragover.prevent
      @drop.prevent="handleDrop"
    >
      <p>Drag & drop a PDF file here, or click to select</p>
      <input type="file" ref="fileInput" @change="handleFileChange" accept="application/pdf" style="display:none" />
      <button @click="$refs.fileInput.click()">Select PDF</button>
    </div>
    <div v-if="uploading">Uploading...</div>
    <div v-if="fileUrl" class="result-box">
      <div class="file-link-area">
        <span>File uploaded:</span>
        <a :href="fileUrl" target="_blank">View PDF</a>
      </div>
      <div class="s3-url-box">
        <input type="text" :value="fileUrl" readonly ref="urlInput" />
        <button class="copy-btn" @click="copyUrl">
          <img src="@/assets/copy.svg" alt="Copy" width="20" height="20" />
        </button>
      </div>
      <div v-if="copied" class="copied-msg">Copied!</div>
    </div>

    <!-- PDF Preview Section -->
    <div v-if="fileUrl" class="pdf-preview-section">
      <h2>PDF Preview</h2>
      <div class="pdf-preview-container">
        <iframe 
          :src="fileUrl" 
          type="application/pdf"
          class="pdf-viewer"
          title="PDF Preview"
        ></iframe>
        <div class="pdf-controls">
          <a :href="fileUrl" download class="download-btn">
            ⬇ Download PDF
          </a>
          <button class="close-preview-btn" @click="closePdfPreview">
            ✕ Close Preview
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import api from '../api';
import MenuBar from './MenuBar.vue';

export default {
  name: 'Home',
  components: {
    MenuBar
  },
  data() {
    return {
      uploading: false,
      fileUrl: '',
      copied: false
    };
  },
  methods: {
    handleDrop(e) {
      const files = e.dataTransfer.files;
      if (files.length) {
        this.uploadFile(files[0]);
      }
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.uploadFile(file);
      }
    },
    async uploadFile(file) {
      this.uploading = true;
      this.fileUrl = '';
      this.copied = false;
      const formData = new FormData();
      formData.append('file', file);
      try {
        const res = await api.post('/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        this.fileUrl = res.data.file_url;
      } catch (err) {
        if (err.response && err.response.status === 401) {
          this.$router.push('/login');
        } else {
          alert('Upload failed');
        }
      } finally {
        this.uploading = false;
      }
    },
    copyUrl() {
      if (!this.fileUrl) return;
      const input = this.$refs.urlInput;
      input.select();
      document.execCommand('copy');
      this.copied = true;
      setTimeout(() => (this.copied = false), 1500);
    },
    closePdfPreview() {
      this.fileUrl = '';
      this.copied = false;
    }
  }
};
</script>

<style scoped>
.home {
  display: flex;
  min-height: 100vh;
  background: #f5f5f5;
}

.home-content {
  flex: 1;
  margin-left: 250px;
  padding: 20px;
  overflow-y: auto;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  max-width: 500px;
}

.header h1 {
  margin: 0;
  font-size: 28px;
  color: #2c3e50;
}

.drop-area {
  border: 2px dashed #aaa;
  padding: 40px;
  margin-bottom: 20px;
  cursor: pointer;
  background: white;
  border-radius: 8px;
  max-width: 500px;
}

.drop-area:hover {
  border-color: #3498db;
  background: #f9f9f9;
}

.drop-area p {
  margin: 0 0 15px 0;
  color: #666;
}

.drop-area button {
  background: #3498db;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.3s ease;
}

.drop-area button:hover {
  background: #2980b9;
}

.result-box {
  margin-top: 24px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  max-width: 500px;
}

.file-link-area {
  margin-bottom: 10px;
}

.file-link-area a {
  color: #3498db;
  text-decoration: none;
  font-weight: 600;
}

.file-link-area a:hover {
  text-decoration: underline;
}

.s3-url-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.s3-url-box input {
  width: 80%;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px 0 0 4px;
  outline: none;
}

.copy-btn {
  background: #f5f5f5;
  border: 1px solid #ccc;
  border-left: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  padding: 0 8px;
  height: 32px;
  display: flex;
  align-items: center;
  transition: background 0.3s ease;
}

.copy-btn:hover {
  background: #e8e8e8;
}

.copied-msg {
  color: #4caf50;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 600;
}

/* PDF Preview Section */
.pdf-preview-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-top: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 100%;
}

.pdf-preview-section h2 {
  margin: 0 0 16px 0;
  font-size: 20px;
  color: #2c3e50;
  border-bottom: 2px solid #3498db;
  padding-bottom: 10px;
}

.pdf-preview-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pdf-viewer {
  width: 100%;
  height: 600px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #f9f9f9;
}

.pdf-controls {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.download-btn,
.close-preview-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.download-btn {
  background: #27ae60;
  color: white;
}

.download-btn:hover {
  background: #229954;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3);
}

.close-preview-btn {
  background: #e0e0e0;
  color: #2c3e50;
}

.close-preview-btn:hover {
  background: #d0d0d0;
  transform: translateY(-2px);
}

/* Responsive: Tablet */
@media (max-width: 768px) {
  .home-content {
    margin-left: 200px;
    padding: 15px;
  }

  .header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .header h1 {
    font-size: 24px;
  }

  .drop-area {
    padding: 30px;
    max-width: 100%;
  }

  .result-box {
    max-width: 100%;
  }

  .s3-url-box input {
    width: 75%;
  }

  .pdf-viewer {
    height: 400px;
  }

  .pdf-controls {
    flex-wrap: wrap;
  }
}

/* Responsive: Mobile */
@media (max-width: 480px) {
  .home {
    flex-direction: column;
  }

  .home-content {
    margin-left: 0;
    padding: 12px;
  }

  .header {
    margin-bottom: 20px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .header h1 {
    font-size: 20px;
  }

  .logout-btn {
    padding: 6px 12px;
    font-size: 12px;
  }

  .drop-area {
    padding: 20px;
    max-width: 100%;
  }

  .drop-area p {
    font-size: 14px;
  }

  .drop-area button {
    width: 100%;
    padding: 12px;
  }

  .result-box {
    max-width: 100%;
    padding: 12px;
  }

  .s3-url-box {
    flex-direction: column;
    gap: 8px;
  }

  .s3-url-box input {
    width: 100%;
    border-radius: 4px;
  }

  .copy-btn {
    width: 100%;
    border-radius: 4px;
    border-left: 1px solid #ccc;
    justify-content: center;
  }

  .pdf-preview-section {
    padding: 12px;
    margin-top: 20px;
  }

  .pdf-preview-section h2 {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .pdf-viewer {
    height: 300px;
  }

  .pdf-controls {
    flex-direction: column;
    gap: 8px;
  }

  .download-btn,
  .close-preview-btn {
    width: 100%;
    padding: 12px;
  }
}
</style>
